// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__1H9eC","footer":"ReportModalFilter_footer__11Y7k"};